import React from 'react';
import SelectionInput from "./SelectionInput";
import NumberInput from "./NumberInput";

function UnitInput(props: UnitInputProps) {
    const {options, label, unitName, numberName, labelAbove} = props
    return (
        <div className="molekules-two-unitinput">
            <NumberInput label={label} name={numberName} labelAbove={labelAbove}/>
            <SelectionInput options={options} name={unitName}/>
        </div>
    );
}

export default UnitInput;
